// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_cLd","cls2":"ClaimDetails-cls2_lbo ClaimDetails-cls1_cLd"};